import { jsx as _jsx } from "react/jsx-runtime";
import Tooltip from './Tooltip';
import OverlayTrigger from '../overlay/OverlayTrigger';
import { PLACEMENT } from '../../values/Placement';
import { TRIGGER } from '../../values/Trigger';
const SimpleTooltip = (props) => {
    const { children, placement = PLACEMENT.AUTO, trigger, content, delay, popperConfig, targetRef, ...remainingProps } = props;
    return (_jsx(OverlayTrigger, { placement: placement, trigger: trigger, overlay: _jsx(Tooltip, { ...remainingProps, ref: targetRef, children: content }), delay: delay, popperConfig: popperConfig, children: children }));
};
SimpleTooltip.TRIGGER_CLICK = TRIGGER.CLICK;
SimpleTooltip.TRIGGER_HOVER = TRIGGER.HOVER;
SimpleTooltip.TRIGGER_FOCUS = TRIGGER.FOCUS;
export default SimpleTooltip;
